import React from 'react';
import PropTypes from 'prop-types';
import SidebarHeader from '@99designs/common/apps/ddo/components/SidebarHeader';
import { likeDesignAction, unlikeDesignAction, updateDesignAction } from 'apps/ddo/actions';
import LikeButton from 'components/LikeButton';
import ShareButtonDropdownMenu from './ShareButtonDropdownMenu';
import DesignAttribution from './DesignAttribution';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import TrackClick from 'components/TrackClick';
import UserInteractionCtas from 'apps/ddo/components/UserInteractionCtas';
import DesignEditButton from 'components/DesignEditButton';

export default class DesignActions extends React.Component {
    constructor(props) {
        super(props);

        this.likeDesign = this.likeDesign.bind(this);
        this.unlikeDesign = this.unlikeDesign.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
    }

    likeDesign(likeCount) {
        this.context.executeAction(likeDesignAction, {
            designId: this.props.design.designId,
            likeCount,
        });
    }

    unlikeDesign(likeCount) {
        this.context.executeAction(unlikeDesignAction, {
            designId: this.props.design.designId,
            likeCount,
        });
    }

    handleFavorite(isFavorite) {
        this.context.executeAction(updateDesignAction, {
            designId: this.props.design.designId,
            creator: {
                ...this.props.design.creator,
                isFavorite,
            },
        });
    }

    linkLikeCount() {
        if (
            this.props.design.likeCount > 0 &&
            this.props.activePane === 'default' &&
            this.props.design.permission.canEdit
        ) {
            return this.props.onLikeCountClick;
        }

        return null;
    }

    render() {
        const { activeUser, design } = this.props;

        return (
            <div>
                <SidebarHeader.Section>
                    <SidebarHeader.Heading>
                        <SidebarHeader.HeadingText>
                            <div> {design.name} </div>
                        </SidebarHeader.HeadingText>
                    </SidebarHeader.Heading>
                    <DesignAttribution
                        design={design}
                        activeUser={activeUser}
                        onFavorite={this.handleFavorite}
                    />
                    <div className="section">
                        {design.permission.canEdit ? (
                            <DesignEditButton designId={design.designId} />
                        ) : (
                            <UserInteractionCtas
                                userId={design.creator.userId}
                                isUserAvailable={!design.permission.designerUnavailable}
                            />
                        )}
                    </div>
                    <ButtonGroup variations={['giant']}>
                        <ButtonGroupItem>
                            <TrackClick
                                event="Element Clicked On Design Overlay"
                                element="like_button"
                            >
                                <LikeButton
                                    isLiked={design.likedByUser}
                                    likeUrl={design.links.likeDesignUrl}
                                    likeCount={design.likeCount}
                                    onLike={this.likeDesign}
                                    onUnlike={this.unlikeDesign}
                                    canLike={design.permission.canLike}
                                    noPermissionMessage={design.login_or_signup}
                                    onLikeCountClick={this.linkLikeCount()}
                                />
                            </TrackClick>
                        </ButtonGroupItem>
                        <ButtonGroupItem>
                            <ShareButtonDropdownMenu design={design} />
                        </ButtonGroupItem>
                    </ButtonGroup>
                </SidebarHeader.Section>
            </div>
        );
    }
}

DesignActions.contextTypes = {
    executeAction: PropTypes.func,
};

DesignActions.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    activePane: PropTypes.string.isRequired,
    onLikeCountClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/DesignActions.jsx